export default [
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      layout: 'full',
      resource: 'auth',
      action: 'read',
    },
  },
  {
    path: '/not-authorized',
    name: 'not-authorized',
    // ! Update import path
    component: () => import('@/views/error/NotAuthorized.vue'),
    meta: {
      layout: 'full',
      resource: 'auth',
      action: 'read',
    },
  },
]
